import { render, staticRenderFns } from "./publicFooter.vue?vue&type=template&id=0225b051&scoped=true"
import script from "./publicFooter.vue?vue&type=script&lang=js"
export * from "./publicFooter.vue?vue&type=script&lang=js"
import style0 from "./publicFooter.vue?vue&type=style&index=0&id=0225b051&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225b051",
  null
  
)

export default component.exports